import { render, staticRenderFns } from "./gradeAdd.vue?vue&type=template&id=32558512&scoped=true&"
import script from "./gradeAdd.vue?vue&type=script&lang=js&"
export * from "./gradeAdd.vue?vue&type=script&lang=js&"
import style0 from "./gradeAdd.vue?vue&type=style&index=0&id=32558512&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32558512",
  null
  
)

export default component.exports